import { Button } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { modals } from '@mantine/modals';
import { notifications } from '@mantine/notifications';
import { IconPlus } from '@tabler/icons-react';

import { RouterOutput, trpc } from '../../../../../services/trpc';
import {
  ConstructionSiteReportForm,
  ConstructionSiteReportFormValues,
} from './-construction-site-report-form';

export function ConstructionSiteReportButton({
  project,
  label,
  initialValues,
}: {
  project: NonNullable<RouterOutput['projects']['get']>;
  label: string;
  initialValues?: ConstructionSiteReportFormValues;
}) {
  const generateConstructionSiteReport =
    trpc.documents.generateConstructionSiteReport.useMutation();

  const isSmallScreen = useMediaQuery('(max-width: 768px)');

  const openAddCSRModal = () => {
    modals.open({
      title: 'Ajouter un PV',
      size: 'xl',
      fullScreen: isSmallScreen,
      children: (
        <ConstructionSiteReportForm
          initialValues={initialValues}
          project={project}
          onSubmit={async values => {
            await generateConstructionSiteReport.mutateAsync({
              projectId: project.id,
              date: new Date(values.date!),
              attendees: values.attendees,
              extraAttendee: values.extraAttendee,
              question1: values.question1!,
              question2: values.question2!,
              question3: values.question3!,
              question4: values.question4!,
              question5: values.question5!,
              question6: values.question6!,
              question3Extra: values.question3Extra!,
              question3ExtraObservations: values.question3ExtraObservations,
              observations: values.observations,
              signer: values.signer,
              signatureUtFileKey: values.signatureUtFileKey,
              imagesUtFileKeys: values.imagesUtFileKeys,
            });
            modals.closeAll();
            notifications.show({
              title: 'PV ajouté avec succès',
              message: '',
              color: 'green',
            });
          }}
        />
      ),
    });
  };

  const handleClick = () => {
    if (!project.installer) {
      notifications.show({
        title: 'Poseur non renseigné',
        message:
          'Veuillez renseigner le poseur dans "Modifier le projet" avant d\'ajouter un PV de chantier.',
        color: 'red',
      });
      return;
    }

    openAddCSRModal();
  };

  return (
    <Button
      variant="outline"
      leftSection={<IconPlus size={16} />}
      onClick={handleClick}
    >
      {label}
    </Button>
  );
}
